module.exports = __webpack_public_path__ + "img/medal-gold.be8f4eb2.png";